export enum EVENTS {
  MACHINE_RESET = 'xstate.done.actor.0.delivery-bar.TRANSITION_CONTEXT_HYDRATION_PENDING',

  // CONTEXT UPDATE
  ADDRESS_SELECT = 'ADDRESS_SELECT',
  SHIPPING_METHOD_SELECT = 'SHIPPING_METHOD_SELECT',
  PICKUP_POINT_SELECT = 'PICKUP_POINT_SELECT',

  //CONTEXT OVERWRITE
  OVERWRITE_ADDRESS = 'OVERWRITE_ADDRESS',
  OVERWRITE_SHIPPING_METHOD = 'OVERWRITE_SHIPPING_METHOD',

  // STATE TRANSITION
  GO_TO_STATE_INITIAL_STATE_RESOLVER = 'GO_TO_STATE_INITIAL_STATE_RESOLVER',
  GO_TO_STATE_ADDRESS_SELECTOR = 'GO_TO_STATE_ADDRESS_SELECTOR',
  GO_TO_STATE_SHIPPING_METHOD_SELECTOR = 'GO_TO_STATE_SHIPPING_METHOD_SELECTOR',
  GO_TO_UPDATE_CUSTOMER_DATA = 'GO_TO_UPDATE_CUSTOMER_DATA',

  // CHILDREN MACHINE ONDONE
  ADDRESS_SELECTION_FLOW_COMPLETE = 'xstate.done.actor.addressSelectorMachine',
  SHIPPING_METHOD_SELECTION_FLOW_COMPLETE = 'xstate.done.actor.shippingMethodSelectorMachine',
  FETCH_ELIGIBLE_SHIPPING_METHODS_COMPLETE = 'xstate.done.actor.fetchShippingMethodsService',
}
